"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showLoginModal = void 0;
var ssrcontext_1 = require("ssrcontext");
var website_1 = require("utils/website");
function showLoginModal() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!ssrcontext_1.runInServer() && website_1.isPC() && website_1.isEzbuy()) {
        if (window["EZ_PAGE_SCOPE"] && window["EZ_PAGE_SCOPE"].LoginAndRegisterKit) {
            (_a = window["EZ_PAGE_SCOPE"].LoginAndRegisterKit).show.apply(_a, args);
        }
    }
}
exports.showLoginModal = showLoginModal;
